// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__TLU4Y","content":"LoadingAlert_content__3roGS"};